<template>
  <div>
    <el-upload
        class="avatar-uploader"
        :action="url"
        ref="uploadImg"
        list-type="picture-card"
        :limit="1"
        :on-change="handleChange"
        :on-remove="handleChange"
        :on-exceed="handleExceed"
        :auto-upload="false">
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{file}">
        <img
          class="el-upload-list__item-thumbnail"
          :src="file.url" alt="" :width="width"
        >
        <span class="el-upload-list__item-actions">
          <!-- <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span> -->
          <span
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img :width="width" :src="file.url" alt="">
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import http from '../../utils/httpRequest'

  export default {
    name: 'UploadImage',
    props: {},
    data() {
      return {
        file: '',
        width: '',
        dialogVisible: false,
        url: http.adornUrl('/file/upload.api')
      }
    },
    methods: {
      handleRemove(file) {
        this.$refs.uploadImg.clearFiles()
        this.file = ''
        this.$emit('listenToChange', this.file)
      },
      handleChange(file) {
        if (file.raw.type === 'image/jpeg' || file.raw.type === 'image/png') {
          let img = new Image()
          img.src = file.url
          img.onload = () => {
            let data = this.compress(img)
            let blob = this.dataURItoBlob(data)
            file.raw = blob
            file.url = data
            this.$refs.uploadImg.uploadFiles[0].url = data
            this.file = file
          }
        } else {
          this.file = ''
          this.$refs.uploadImg.clearFiles()
          this.$message.warning('请上传jpg或png格式的图片')
        }
        this.$emit('listenToChange', this.file)
      },
      handlePictureCardPreview(file) {
        this.file = file
        this.dialogVisible = true
      },
      handleExceed(files, fileList) {
        this.$message.warning('只允许添加一张图片')
      },
      // 压缩图片
      compress(img) {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        let width = img.width
        let height = img.height
        if (height > width) {
          height = (height / width) * 70
          width = 70
        } else {
          width = (width / height) * 70
          height = 70
        }
        this.width = width
        canvas.width = width
        canvas.height = height
        // 铺底色
        ctx.fillStyle = '#fff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(img, 0, 0, width, height)
        // 进行压缩
        let ndata = canvas.toDataURL('image/png', 0.9)
        return ndata
      },
      // base64转成bolb对象
      dataURItoBlob(base64Data) {
        let byteString
        if (base64Data.split(',')[0].indexOf('base64') >= 0) { byteString = atob(base64Data.split(',')[1]) } else { byteString = unescape(base64Data.split(',')[1]) }
        let mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0]
        let ia = new Uint8Array(byteString.length)
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }
        return new Blob([ia], { type: mimeString })
      }
    }
  }
</script>

<style lang="stylus">
  .avatar-uploader
    .el-upload-list--picture-card
      .el-upload-list__item
        width auto
        height auto
</style>
